<template>
  <ui-dialog
    :show="show"
    :title="dialogTitle"
    persistent
    scrollable
    @input="$emit('close')"
  >
    <SectionSelectForm
      v-if="step === 1"
      :choices="choices"
      :section-type.sync="sectionType"
      :section-name.sync="sectionName"
    />
    <template v-if="step === 2">
      <div>
        {{ description }}
      </div>
      <LinkSectionForm :data.sync="elements" ref="sectionForm" />
    </template>
    <template #actions>
      <ui-button
        outlined
        color="primary"
        :class="{ hidden: step === 1 }"
        @click="step = 1"
      >
        {{ $t("message.common.back") }}
      </ui-button>
      <BulletStepsIndicator :steps="2" :current-step="step" />
      <ui-button
        v-if="step === 1"
        color="primary"
        min-width="100"
        @click="step = 2"
      >
        {{ $t("message.common.next") }}
      </ui-button>
      <ui-button
        v-if="step === 2"
        :loading="loading"
        color="primary"
        min-width="100"
        @click="handleSave"
      >
        {{ $t("message.common.save") }}
      </ui-button>
    </template>
  </ui-dialog>
</template>

<script>
import BulletStepsIndicator from "@/components/Stepper/BulletStepsIndicator.vue";
import SectionSelectForm from "@/components/StoreLocator/StoreLocatorSectionSelectForm.vue";
import LinkSectionForm from "@/components/StoreLocator/section-forms/LinkSectionForm.vue";

import storeLocatorService from "@/services/storeLocator";
import serviceHandler from "@/helpers/handlers/service";
import { SECTION_TYPES } from "@/enums/section-types.enum";

import { storeLocatorMixin } from "@/helpers/mixins/store-locator";

export default {
  name: "AddSectionDialog",
  components: {
    BulletStepsIndicator,
    SectionSelectForm,
    LinkSectionForm
  },
  mixins: [storeLocatorMixin],
  props: {
    show: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      step: 1,
      sectionType: SECTION_TYPES.LINK_SECTION,
      sectionName: "",
      choices: [
        {
          label: this.$t("message.storeLocator.extraInfo.linkSection.label"),
          title: this.$t("message.storeLocator.extraInfo.linkSection.titleAdd"),
          description: this.$t(
            "message.storeLocator.extraInfo.linkSection.description"
          ),
          value: SECTION_TYPES.LINK_SECTION
        }
      ],
      elements: [],
      loading: false
    };
  },
  methods: {
    async handleSave() {
      const isValid = await this.$refs.sectionForm.validate();
      if (!isValid) return;
      const items = this.elements.map(fields => ({
        ...fields,
        element_type: this.sectionType
      }));
      const payload = {
        name: this.sectionName,
        items
      };
      this.loading = true;
      const facilityId = this.$route.params.id;
      const newSection = await serviceHandler(
        storeLocatorService.createExtraInfoSection(facilityId, payload)
      );
      this.loading = false;
      this.$emit("created", newSection);
      this.elements = [];
      this.sectionName = "";
      this.step = 1;
    }
  },
  computed: {
    dialogTitle() {
      if (this.step === 1) {
        return this.$t("message.storeLocator.extraInfo.selectSectionType");
      }
      return this.title;
    }
  }
};
</script>
